var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-chip-group', {
    model: {
      value: _vm.selectedCategory,
      callback: function callback($$v) {
        _vm.selectedCategory = $$v;
      },
      expression: "selectedCategory"
    }
  }, [!_vm.hideSuggestions ? _c('v-chip', {
    attrs: {
      "color": _vm.selectedCategory === _vm.SUGGESTION ? 'info' : '',
      "value": _vm.SUGGESTION
    }
  }, [_c('span', {
    staticClass: "mr-1",
    staticStyle: {
      "margin-top": "-2px"
    }
  }, [_c('a-eicon', {
    attrs: {
      "noColor": true
    }
  })], 1), _vm._v(" " + _vm._s(_vm.$t("common.nouns.suggestion")) + " ")]) : _vm._e(), _vm._l(_vm.categories, function (cat) {
    return _c('v-chip', {
      key: 'refs-select-cats' + cat,
      attrs: {
        "color": _vm.selectedCategory === cat ? 'info' : '',
        "value": cat
      },
      domProps: {
        "textContent": _vm._s(_vm.getRefTypeName(cat))
      }
    });
  })], 2)], 1), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.search'),
      "dense": "",
      "outlined": "",
      "append-icon": "mdi-magnify"
    },
    on: {
      "input": _vm.debounceSetSearchFilter
    },
    model: {
      value: _vm.searchFilter,
      callback: function callback($$v) {
        _vm.searchFilter = $$v;
      },
      expression: "searchFilter"
    }
  }), _vm.loading ? _c('v-progress-linear', {
    staticClass: "mt-n6",
    attrs: {
      "color": "info",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm.SUGGESTION === _vm.selectedCategory && !_vm.hideSuggestions ? _c('refs-selection-suggestion', {
    attrs: {
      "loading": _vm.loading,
      "suggested": _vm.suggested,
      "partnerId": _vm.partnerId,
      "matchesFilter": _vm.matchesFilter,
      "isSelected": _vm.isSelected
    },
    on: {
      "addToSelected": _vm.addToSelected
    }
  }) : _vm.RefTypeMap.get(_vm.selectedCategory) && _vm.list && _vm.list.length ? _c('virtual-list', {
    key: 'virtual-list' + _vm.selectedCategory,
    staticStyle: {
      "max-height": "500px",
      "overflow": "auto"
    },
    attrs: {
      "data-component": {},
      "data-sources": _vm.list,
      "data-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item,
            index = _ref.index;
        return [_c('v-card', {
          staticClass: "mt-1 mb-1",
          attrs: {
            "outlined": ""
          }
        }, [_c('v-list-item', {
          on: {
            "click": function click($event) {
              return _vm.addToSelected({
                ref: item,
                refType: _vm.selectedCategory
              });
            }
          }
        }, [_c('v-list-item-icon', {
          staticClass: "mr-n2"
        }, [_c('v-icon', [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.selectedCategory).icon) + " ")])], 1), _c('v-list-item-content', {
          staticClass: "pa-0"
        }, [item && item ? _c('refs-list', {
          attrs: {
            "item": item,
            "refType": _vm.selectedCategory,
            "small": true
          },
          on: {
            "openDetail": function openDetail(item) {
              return _vm.addToSelected({
                ref: item,
                refType: _vm.selectedCategory
              });
            }
          }
        }) : _vm._e()], 1), _vm.isSuggested(item) ? _c('v-list-item-icon', [_c('a-eicon')], 1) : _vm._e()], 1)], 1), index === _vm.list.length - 1 && _vm.isLoadMorePossible ? _c('v-btn', {
          staticClass: "my-1",
          attrs: {
            "outlined": "",
            "text": "",
            "elevation": 0,
            "block": "",
            "loading": _vm.isLoadingMore
          },
          on: {
            "click": function click($event) {
              return _vm.loadMore(_vm.selectedCategory);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportList.loadMore")) + " ")]) : _vm._e()];
      }
    }])
  }) : _c('v-list-item', [_c('latest-entries-card-empty')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }